export const ROUTES = {
  home: '/',
  signIn: '/signin',
  admins: '/admins',
  profile: '/profile',
  contentChange: '/content/edit',
  textComment: '/content/edit/text-comments',
  videoComment: '/content/edit/video-comments',
  courses: '/content/edit/courses',
  images: '/content/edit/images',

  blogs: '/blogs',
  blogsPosts: '/blogs/posts',
  blogsCategories: '/blogs/categories',
  blogCategoriesSingle: '/blogs/categories/:categoryId',
  blogsUnArchiveAdd: '/blogs/unarchive/add',
  blogsArchiveAdd: '/blogs/archive/add',
  blogUnArchiveEdit: '/blogs/archive/:blogId/edit',
  blogArchive: '/blogs/archive',
  blogUnArchive: '/blogs/unarchive',
  post: '/blogs/posts',
  seo: '/seo',
  blog: '/blog',

  hrSection: '/hr-section',
  hrSectionVacancies: '/hr-section/vacancies',
  hrSectionVacanciesSingle: '/hr-section/vacancies/:id',
  hrSectionOurTeam: '/hr-section/our-team',
  hrSectionNews: '/hr-section/news',
  hrSectionNewsAdd: '/hr-section/news/add',
  hrSectionNewsEdit: '/hr-section/news/:id/edit',
  hrSectionNewsCategory: '/hr-section/news-category',
  hrSectionNewsCategoryId: '/hr-section/news-category/:id',
} as const
